module.exports = __webpack_public_path__ + "img/service3-04.8d2405d2.png";